import React, {useEffect, useState} from "react";
/** @jsxImportSource @emotion/react */
import {css} from "@emotion/react";
import styled from "@emotion/styled";
import {useTheme} from "@emotion/react";
import FindEmailForm from "./component/FindEmailForm";
import FindPasswordForm from "./component/FindPasswordForm";
import {
    BROADCAST_ON_PASS_MOBILE_HEADER_TITLE,
    getImageUrl,
    useApplicationContext,
} from "../../context/ApplicationContextProvider";
import {HEADER_TYPE_LOGO_ONLY} from "../_common/section/Header";
import {FOOTER_TYPE_NONE} from "../_common/section/Footer";
import {useMobileDetect} from "../../utils/Hooks";

const ContainerFindAccount = () => {
    // ApplicationContext
    useApplicationContext({
        header: {
            type: HEADER_TYPE_LOGO_ONLY,
            with_spacing: false,
        },
        footer: {
            type: FOOTER_TYPE_NONE,
        },
    });

    const {is_mobile} = useMobileDetect();
    const {broadcast} = useApplicationContext();

    // state
    const [is_email, setIsEmail] = useState(true);

    // css style
    const {css, view} = useComponentStyle(is_mobile);

    useEffect(() => {
        setIsEmail(window.location.pathname === "/account/find-email");
        if (window.location.pathname === "/account/find-email") {
            broadcast.send(BROADCAST_ON_PASS_MOBILE_HEADER_TITLE, "아이디 찾기");
        } else {
            broadcast.send(BROADCAST_ON_PASS_MOBILE_HEADER_TITLE, "비밀번호 찾기");
        }
    }, [broadcast, is_email]);

    return (
        <div css={css.find_account_container_css}>
            <view.TitleSection>
                {is_email ? (
                    <>
                        {!is_mobile && <view.Title>아이디 찾기</view.Title>}
                        <view.Description>
                            <div className="tip-icon" />
                            <span>
                                가입시 입력하신 정보를&nbsp;
                                {is_mobile && <br />}
                                정확히 입력해주세요. <br />
                            </span>
                        </view.Description>
                    </>
                ) : (
                    <>
                        {!is_mobile && <view.Title>비밀번호 찾기</view.Title>}
                        <view.Description>
                            <div className="tip-icon" />
                            <span>
                                가입하신 이메일 주소를&nbsp;
                                {is_mobile && <br />}
                                정확히 입력해주세요.
                            </span>
                        </view.Description>
                    </>
                )}
            </view.TitleSection>
            {is_email ? <FindEmailForm /> : <FindPasswordForm />}
        </div>
    );
};

export default ContainerFindAccount;

export const useComponentStyle = (is_mobile) => {
    const theme = useTheme();
    return {
        css: {
            find_account_container_css: css({
                width: "95%",
                maxWidth: "400px",
                minWidth: "15em",
                height: "100%",
                margin: is_mobile ? "6em auto 0 auto" : "5em auto 0 auto",
            }),
        },
        view: {
            TitleSection: styled.div({
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                width: "100%",
                marginBottom: "3em",
            }),
            Title: styled.div({
                fontSize: theme.font_size.f22,
                fontWeight: "700",
                marginBottom: "1em",
            }),
            Description: styled.div({
                transform: is_mobile && "translateX(-10%)",
                display: "flex",
                fontSize: theme.font_size.f15,
                fontWeight: "400",
                color: theme.colors.dg2,
                marginBottom: "2em",
                textAlign: "center",
                "& > .tip-icon": {
                    width: "1.3em",
                    height: "1.3em",
                    transform: !is_mobile && "translateY(-5%)",
                    marginRight: ".5em",
                    background: `url(${getImageUrl("image/common/ic_tip_x3.png")}) center center/contain no-repeat`,
                },
            }),
        },
    };
};
